export default "__VITE_ASSET__CxFRJPmK__"